import format from 'date-fns/format';

export const cleanDate = value =>{
  if(value){
    console.log(value, 'raw date');
    console.log(format(new Date(value), 'DD MMMM, YYYY'), 'val');
    return format(new Date(value), 'DD MMMM, YYYY');
  }

};